import Cookies from 'js-cookie';
import decodeAuthenticationToken from './decodeAuthenticationToken';

const defaultOptions = {
  checkExpiration: true,
};

export default function getAuthenticationToken(options = defaultOptions) {
  const cookieAuthenticationToken = Cookies.get('authentication-token');

  if (cookieAuthenticationToken === undefined) {
    return undefined;
  }

  if (options.checkExpiration) {
    const decodedToken = decodeAuthenticationToken(cookieAuthenticationToken);

    if (decodedToken === null) {
      return undefined;
    }

    if (decodedToken.exp <= Date.now() / 1000) {
      return undefined;
    }
  }

  return cookieAuthenticationToken;
}
